<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 pb-2 ziro-datatable-content">
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    <div [hidden]="isLoading">
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <div
            [innerHTML]="
              isDraftOrder
                ? ('tkey;admin.order_numbers.port_in_drafts_edit.about' | escapeHtml)
                : ('tkey;admin.order_numbers.view_orders.about' | escapeHtml)
            "
          ></div>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>

      @if (!isLoading) {
        <div>
          <!--   PHONE NUMBERS ERROR ALERT     -->
          @if (!isDraftOrder && !!errors) {
            <div [attr.data-automation]="'error-banner'" class="alert alert-danger" role="alert">
              <i [ngClass]="ziroIcons.WARNING_TRIANGLE"></i>
              <strong [attr.data-automation]="'error-code'">
                {{ ('tkey;admin.order_numbers.port_in_drafts_edit.errors.label' | translate) + ' ' + errors.code }}
              </strong>
              -
              <span [attr.data-automation]="'error-description'">{{ errors.description }}</span>
              @if (errors.telephoneNumberList.length) {
                <div [attr.data-automation]="'error-number-list'">
                  {{ 'tkey;admin.order_numbers.port_in_drafts_edit.errors.numbers.label' | translate }}:
                  <!-- prettier-ignore-->
                  @for (number of errors.telephoneNumberList; track number; let last = $last) {
                    <span>
                      {{ number | telephoneNumberFilter }}@if (!last) {
                      <span>, </span>
                    }
                  </span>
                }
                </div>
              }
            </div>
          }
          <!--   PHONE NUMBERS CARD     -->
          <ziro-collapsible-section-card
            [title]="'tkey;admin.order_numbers.order_view_and_edit.phone_numbers.label'"
            [icon]="ziroIcons.DESKPHONE_SMALL"
            [isOpenInput]="true"
            [dataAutomation]="'phone-numbers'"
            [isCollapsible]="true"
          >
            <ziro-datatable
              [columns]="phoneNumbersTableCols"
              [rowDataSource]="phoneNumbersTableRows"
              [uniqueRowIdentifier]="'number'"
              [mainFilterPlaceholder]="
                'tkey;admin.order_numbers.order_view_and_edit.phone_numbers.datatable.search.placeholder' | translate
              "
              [setColumnWidths]="false"
              [containerCard]="true"
              [stickyColumnCount]="1"
              [dataAutomation]="tableDataAutomation"
              [matchesSecondaryDataFn]="matchesSecondaryDataFn"
            >
              <ziro-datatable-multi-select-filter
                [label]="'tkey;admin.order_numbers.order_view_and_edit.phone_numbers.table.user.filter.label'"
                [items]="userFilterOptions"
                [matchFn]="onUpnFilterChange"
                [labelCssClass]="'text-capitalize'"
                [dataAutomation]="'user-filter'"
                [tableId]="tableDataAutomation"
              ></ziro-datatable-multi-select-filter>
              <ziro-datatable-multi-select-filter
                [label]="'tkey;admin.order_numbers.order_view_and_edit.phone_numbers.table.dial_plan.label'"
                [items]="dialPlanGroupFilterOptions"
                [matchFn]="onDialPlanFilterChange"
                [labelCssClass]="'text-capitalize'"
                [dataAutomation]="'dial-plan-filter'"
                [tableId]="tableDataAutomation"
              ></ziro-datatable-multi-select-filter>
              <ziro-datatable-multi-select-filter
                [label]="'tkey;admin.order_numbers.order_view_and_edit.phone_numbers.table.sbc_config.label'"
                [items]="sbcConfiguredFilterOptions"
                [matchFn]="onSbcConfiguredFilterChange"
                [labelCssClass]="'text-capitalize'"
                [dataAutomation]="'sbc-configured-filter'"
                [tableId]="tableDataAutomation"
              ></ziro-datatable-multi-select-filter>
            </ziro-datatable>
          </ziro-collapsible-section-card>
          <!--   DOCUMENTS CARD     -->
          <ziro-collapsible-section-card
            [title]="'tkey;admin.order_numbers.port_in_drafts_edit.documents.label'"
            [icon]="ziroIcons.DOCUMENTS"
            [isOpenInput]="true"
            [dataAutomation]="'documents'"
            [isCollapsible]="true"
          >
            <div>
              <ziro-datatable
                [columns]="documentsTableColumns"
                [rowDataSource]="documentsRows"
                [uniqueRowIdentifier]="'documentId'"
                [dataAutomation]="'documents-table-view'"
              ></ziro-datatable>
            </div>
            @if (isDraftOrder) {
              <div class="text-end mt-2 mb-4">
                @if (!loaIsPresent) {
                  <ziro-button
                    [icon]="ziroIcons.PDF"
                    [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
                    class="me-1"
                    [dataAutomation]="'generate-loa-button'"
                    [label]="'tkey;admin.order_numbers.order_view_and_edit.documents.generate_loa.button.label'"
                    [isDisabled]="!!generateLoaButtonDisabledTooltip"
                    [tooltip]="generateLoaButtonDisabledTooltip"
                    [isTooltipDisabled]="!generateLoaButtonDisabledTooltip"
                    (clicked)="onGenerateLoaClick()"
                  ></ziro-button>
                }
                <ziro-button
                  [icon]="ziroIcons.ADD"
                  [dataAutomation]="'new-draft-document-button'"
                  [label]="'tkey;admin.order_numbers.port_in_drafts_edit.documents.add_button.label'"
                  (clicked)="onNewDocumentClick()"
                ></ziro-button>
              </div>
            }
          </ziro-collapsible-section-card>
        </div>
      }
      <div class="row">
        <div class="mb-4 col-md-6">
          <!--   ORDER/DRAFT INFORMATION CARD     -->
          <div data-automation="draft-info">
            <ziro-collapsible-section-card
              [title]="
                isDraftOrder
                  ? 'tkey;admin.order_numbers.port_in_drafts_edit.draft_information.label'
                  : 'tkey;admin.order_numbers.view_orders.title'
              "
              [icon]="ziroIcons.DRAFT"
              [isCollapsible]="false"
            >
              <ziro-text [fieldId]="'customerOrderId'"></ziro-text>
              @if (!isDraftOrder) {
                <div>
                  <ziro-text [fieldId]="'processingStatus'"></ziro-text>
                  <ziro-text [fieldId]="'actualFocDate'"></ziro-text>
                  <ziro-text [fieldId]="'orderCreatedDate'"></ziro-text>
                  <ziro-text [fieldId]="'lastModifiedDate'"></ziro-text>
                  <ziro-text [fieldId]="'lastModifiedBy'"></ziro-text>
                  <ziro-text [fieldId]="'requestedFocDate'"></ziro-text>
                </div>
              }
              @if (isDraftOrder) {
                <div>
                  <ziro-date [fieldId]="'desiredFocDate'"></ziro-date>
                </div>
              }
              <ziro-text [fieldId]="'losingCarrierName'"></ziro-text>
              <ziro-text [fieldId]="'rateCenterName'"></ziro-text>
              <ziro-checkbox [fieldId]="'partialPort'"></ziro-checkbox>
              <ziro-text [fieldId]="'newBillingTelephoneNumber'"></ziro-text>
              @if (!isDraftOrder) {
                <div>
                  <ziro-checkbox [fieldId]="'losingCarrierIsWireless'"></ziro-checkbox>
                </div>
              }
            </ziro-collapsible-section-card>
          </div>
        </div>
        <div class="col-md-6">
          <!--   ACCOUNT INFORMATION CARD     -->
          <div data-automation="account-info">
            <ziro-collapsible-section-card
              [title]="'tkey;admin.order_numbers.port_in_drafts_edit.account_information.label'"
              [icon]="ziroIcons.USER_INFO"
              [isCollapsible]="false"
            >
              <ziro-text [fieldId]="'loaAuthorizingPerson'"></ziro-text>
              <ziro-text [fieldId]="'billingTelephoneNumber'"></ziro-text>
              <ziro-text [fieldId]="'accountNumber'"></ziro-text>
              <ziro-text [fieldId]="'pinNumber'"></ziro-text>
              <ziro-text [fieldId]="'businessName'"></ziro-text>
            </ziro-collapsible-section-card>
          </div>

          <!--   ADDRESS CARD    -->
          <div data-automation="address-info">
            <ziro-collapsible-section-card
              [title]="'tkey;admin.order_numbers.port_in_drafts_edit.address.label'"
              [icon]="ziroIcons.ADDRESS"
              [isCollapsible]="false"
            >
              <ziro-text [fieldId]="'houseNumber'"></ziro-text>
              <ziro-text [fieldId]="'streetName'"></ziro-text>
              <ziro-text [fieldId]="'addressLine2'"></ziro-text>
              <ziro-text [fieldId]="'city'"></ziro-text>
              @if (isDraftOrder) {
                <div>
                  <ziro-select [fieldId]="'stateCode'"></ziro-select>
                </div>
              }
              @if (!isDraftOrder) {
                <div>
                  <ziro-text [fieldId]="'stateCode'"></ziro-text>
                </div>
              }
              <ziro-text [fieldId]="'country'"></ziro-text>
              <ziro-text [fieldId]="'zip'"></ziro-text>
            </ziro-collapsible-section-card>
          </div>
        </div>
      </div>
      <!--   NOTES CARD-->
      @if (!isDraftOrder) {
        <div [attr.data-automation]="'notes-card'">
          <ziro-collapsible-section-card
            [title]="'tkey;admin.order_numbers.port_in_orders.datatable.note.header'"
            [icon]="ziroIcons.NOTES"
            [isCollapsible]="false"
          >
            @for (note of notes; track note; let i = $index) {
              <ziro-order-note
                [note]="note"
                [isLastNote]="i === notes.length - 1 && notes.length > 1"
                [index]="i"
              ></ziro-order-note>
            }
          </ziro-collapsible-section-card>
        </div>
      }
    </div>
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
